<div class="container py-4" *ngIf="cat">
  <nav class="breadcrumb small mb-3">
    <span class="breadcrumb-item"><a routerLink="/tienda">Tienda</a></span>
    <span class="breadcrumb-item active">{{ cat.name }}</span>
  </nav>

  <h2 class="mb-3">{{ cat.name }}</h2>

  <div class="row g-3">
    <div class="col-6 col-md-4 col-lg-3" *ngFor="let p of items">
      <app-product-card [p]="p"></app-product-card>
    </div>
  </div>
</div>
